
<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2023-05-24 10:15:30
 * @LastEditors: xgx
 * @LastEditTime: 2023-07-27 10:05:48
-->
<template>
  <el-dialog
    title="选择承办单位"
    :visible.sync="dialogVisible"
    width="900px"
    :before-close="cancellation"
  >
    <div>
      <div class="title-box">
        <i class="el-icon-info icon-title"></i>
        <div>
          <div>1. 请选择所需发送的承办单位名称，该单位下的所有管理员均能收到此信息；</div>
          <div>2. 选择父级组织时，其子级组织不会被选择，以避免超范围发送。</div>
        </div>
      </div>
      <div class="column-box">
        <div class="left">
          <a-input-search
            style="width: 100%"
            placeholder="搜索组织名称"
            @search="onSearch"
            v-model="value"
          />
          <a-spin :spinning="loading">
            <div class="tree-box">
              <a-tree
                :expanded-keys="expandedKeys"
                v-model="checkedKeys"
                :auto-expand-parent="autoExpandParent"
                checkable
                :checkStrictly="true"
                @check="onSelect"
                :tree-data="treeData"
                @expand="onExpand"
              />
            </div>
          </a-spin>
        </div>
        <div class="right">
          <div class="right-title">
            <div class="num-box">已选 {{ listData.length }} 个栏目</div>
            <div @click="qingkong" class="btn-box">清空</div>
          </div>
           <a-spin :spinning="loading">
            <div class="right-box">
                <div class="right-one" v-for="(item, index) in listData">
                  <div class="name-box"><span :title="item.orgName">{{ item.orgName }}</span></div>
                  <i
                    @click="deleteOne(item, index)"
                    class="ri-close-fill icon-txt"
                  ></i>
                </div>
            </div>
          </a-spin>
        </div>
      </div>
      <div class="dis-box">
        <div @click="cancellation" class="chanle">取消</div>
        <el-button
          :loading="submitLoading"
          @click="submitBtn"
          class="submit"
          type="primary"
          >保存</el-button
        >
      </div>
    </div>
  </el-dialog>
</template>
<script >
import { tree } from "./index";
export default {
  components: {},
  data() {
    return {
      loading: false,
      expandedKeys: [],
      autoExpandParent: true,
      checkedKeys: [],
      selectedKeys: [],
      treeData: [],
      reqTreeData:[],
      value: "",
      partOld: [],
      submitLoading: false,
      listData: [],
      codeData:[],
      checkedKeysTwo:[],
    };
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    dataSource: {
      type: Array,
      default: [],
    },
  },
  mounted() {
    this.getList();
     this.codeData = JSON.parse(sessionStorage.getItem('menuData'))
  },
  methods: {
    deleteOne(item, indexTwo) {
      this.listData.splice(indexTwo, 1);
      for (let index = 0; index < this.checkedKeys.checked.length; index++) {
        const element = this.checkedKeys.checked[index];
        if (element == item.id) {
          this.checkedKeys.checked.splice(index, 1);
        }
      }
      this.checkedKeys = JSON.parse(JSON.stringify(this.checkedKeys))
      this.onSelect(this.checkedKeys);
    },
    qingkong() {
      this.listData = [];
      this.checkedKeys = {
        checked: [],
        halfChecked: [],
      };
      this.onSelect(this.checkedKeys);
    },
    handleClose() {
      this.$emit("handleClose");
    },
    cancellation() {
      this.$emit("cancellation");
    },
    onSearch() {
      if (this.value === "") {
        this.treeData = this.reqTreeData;
        return;
      }
      let newData = JSON.parse(JSON.stringify(this.treeData));
      this.treeData = this.filterTree(newData, this.value);
      this.autoExpandParent = true;
    },
    onExpand(expandedKeys) {
      this.expandedKeys = expandedKeys;
      this.autoExpandParent = false;
    },
    filterTree(arr, keyword, first = true) {
      console.log('sssssssssss')
      if (first) {
        //首次传入深度克隆数据防止修改源数据
        arr = JSON.parse(JSON.stringify(arr));
      }
      let emptyArr = [];
      for (let item of arr) {
        if (item.title.includes(keyword)) {
          // if (item.children &&Array.isArray(item.children)&& item.children.length > 0) {
          //     item.children = this.filterTree(item.children, keyword,false);
          // }
          emptyArr.push(item);
          this.expandedKeys.push(item.key)
        } else if (
          item.children &&
          Array.isArray(item.children) &&
          item.children.length > 0
        ) {
          item.children = this.filterTree(item.children, keyword, false);
          if (item.children.length) {
            emptyArr.push(item);
             this.expandedKeys.push(item.key)
          }
        }
      }
      return emptyArr;
    },
    submitBtn() {
         this.$emit('handleClose',this.listData)
    },
    onSelect(checkedKeys) {
      let arrayNames = [];
      for (let index = 0; index < checkedKeys.checked.length; index++) {
        const element = checkedKeys.checked[index];
        let names = this.findParentsName(this.treeData, element);
        arrayNames.push({
          orgName: names.reverse().join("/"),
          id: element,
        });
      }
      this.listData = arrayNames;
    },
    findParentsTwo(treeData, id) {
      let allparents = [];
      let findele = (data, id) => {
        if (!id) return;
        data.forEach((item, index) => {
          if (item.key == id) {
            allparents.unshift(item);
          } else {
            if (!!item.children) {
              findele(item.children, id);
            }
          }
        });
      };
      findele(treeData, id);
      return allparents;
    },
    findParents(treeData, id) {
      let allparents = [];
      let findele = (data, id) => {
        if (!id) return;
        data.forEach((item, index) => {
          if (item.key == id) {
            allparents.push(id);
            findele(treeData, item.parentId);
          } else {
            if (!!item.children) {
              findele(item.children, id);
            }
          }
        });
      };
      findele(treeData, id);
      return allparents;
    },
    findParentsName(treeData, id) {
      let allparents = [];
      let findele = (data, id) => {
        if (!id) return;
        data.forEach((item, index) => {
          if (item.key == id) {
            allparents.push(item.title);
            findele(treeData, item.id);  // parentId
          } else {
            if (!!item.children) {
              findele(item.children, id);
            }
          }
        });
      };
      findele(treeData, id);
      return allparents;
    },
    getList() {
      this.loading = true;
      tree({
        siteId: sessionStorage.getItem("siteId"),
        columnName:this.value,
      }).then((res) => {
        if (res.code == 0) {
          let options = JSON.stringify(res.data)
            .replace(/organizationName/g, "title")
            .replace(/id/g, "key");
          this.treeData = JSON.parse(JSON.stringify(JSON.parse(options)));
          this.reqTreeData = this.treeData;
          let array = [];
          for (let index = 0; index < this.dataSource.length; index++) {
            const element = this.dataSource[index];
            array.push(element.id);
            let arrayf = this.findParents(this.treeData, element.id);
            this.checkedKeysTwo.push(...arrayf);
          }
          this.checkedKeysTwo = JSON.parse(JSON.stringify(this.checkedKeysTwo)) || [];
          this.expandedKeys = this.checkedKeysTwo;
          this.checkedKeys = {
            checked: array,
            halfChecked: [],
          };
          this.onSelect(this.checkedKeys);
        }
        this.loading = false;
      });
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .el-dialog {
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 1);
  border: 1px solid rgba(187, 187, 187, 1);
}
/deep/ .el-dialog__title {
  color: rgba(48, 49, 51, 1);
  font-size: 18px;
  text-align: left;
  font-family: HarmonyOS_Sans_SC-bold;
  font-weight: 600;
}
/deep/ .el-icon-close {
  font-weight: 600;
  color: rgba(48, 49, 51, 1);
  font-size: 20px;
}
/deep/ .table {
  margin: 0px;
}
/deep/ .el-dialog__body {
  padding-top: 10px;
}
.title-box {
  display: flex;
  border-radius: 4px;
  background-color: rgba(244, 244, 245, 1);
  padding: 8px 10px;
  color: rgba(144, 147, 153, 1);
  font-size: 13px;
  text-align: left;
  font-family: HarmonyOS_Sans_SC-regular;
  .icon-title {
    color: #a9aab1;
    transform: rotate(-13deg);
    margin-top: 3px;
    margin-right: 2px;
  }
  /deep/ .anticon-close {
    color: rgba(48, 49, 51, 1);
    font-size: 20px;
    font-weight: bold;
  }
}
.column-box {
  height: 420px;
  line-height: 20px;
  border-radius: 4px;
  background-color: rgba(255, 255, 255, 1);
  color: rgba(16, 16, 16, 1);
  font-size: 14px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(228, 231, 237, 1);
  margin-top: 20px;
}
.chanle {
  width: 68px;
  height: 36px;
  line-height: 20px;
  border-radius: 4px;
  background-color: rgba(255, 255, 255, 1);
  color: rgba(16, 16, 16, 1);
  font-size: 14px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(211, 212, 214, 1);
  line-height: 36px;
  cursor: pointer;
}
.submit {
  width: 68px;
  height: 36px;
  border-radius: 4px;
  background-color: rgba(23, 109, 230, 1);
  color: rgba(16, 16, 16, 1);
  font-size: 14px;
  text-align: center;
  font-family: Roboto;
  margin-left: 14px;
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.dis-box {
  display: flex;
  margin-top: 20px;
  text-align: right;
  justify-content: flex-end;
}
.column-box {
  display: flex;
  .right {
    width: 440px;
    border-left: solid 1px rgba(228, 231, 237, 1);
    padding: 14px;
    padding-right: 0px;
    width: 425px;
    padding: 14px;
    border-left: solid 1px rgba(228, 231, 237, 1);
    .right-box{
      max-height: 353px;
      overflow-y: auto;
      min-height: 200px;
    }
    .right-title {
      display: flex;
      justify-content: space-between;
      .num-box {
        height: 36px;
        color: rgba(48, 49, 51, 1);
        font-size: 14px;
        font-family: HarmonyOS_Sans_SC-regular;
        display: flex;
        align-items: center;
      }
      .btn-box {
        height: 36px;
        color: rgba(23, 109, 230, 1);
        font-size: 14px;
        font-family: Roboto-regular;
        display: flex;
        align-items: center;
        padding-right: 14px;
        cursor: pointer;
      }
    }
    .right-one {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 36px;
      align-items: center;
      background-color: rgba(255, 255, 255, 1);
      .icon-txt {
        font-size: 18px;
        color: rgba(48, 49, 51, 1);
        font-weight: 600;
        cursor: pointer;
      }
      .name-box {
        width: 300px;
        overflow: hidden;
        white-space: nowrap;
        text-align: left;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
      }
    }
  }
  .left {
    flex: 1;
    padding: 14px;
    overflow-x: auto;
    /deep/ .ant-input {
      height: 36px;
      text-indent: 24px;
    }
    /deep/ .ant-input-affix-wrapper .ant-input-suffix {
      left: 10px;
      background: #fff;
      width: 20px;
    }
    /deep/ .ant-input-search-icon {
      font-size: 18px;
    }
    /deep/ .ant-tree {
      text-align: left;
    }
    .tree-box {
      overflow-y: auto;
      height: 325px;
      margin-top: 20px;
    }
  }
}
@media screen and (max-width: 720px) {
  .column-box{
    display: block !important;
    height: 50vh !important;
  }
  .column-box .left .tree-box{
    height: 16vh !important;
    margin-top: 0px !important;
  }
  .column-box .right {
    width: auto !important;
    border-left: none !important;
  }
  .column-box .right .right-box{
    height: 17vh !important;
    min-height: auto !important;
  }
  .title-box{
    font-size: 10px !important;
  }
  /deep/ .el-dialog__title{
    font-size: 14px !important;
  }
  /deep/ .el-dialog__body{
    padding: 20px 20px !important;
    padding-top: 10px !important;
  }
}
</style>
